import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "MailFolderView" */ './lazyIndex');
});
export { default as FolderNode } from './components/FolderNode';
export { default as MailFolderList } from './components/MailFolderList';
export { DRAG_X_OFFSET, DRAG_Y_OFFSET } from './helpers/folderNodeDragConstants';
// Delay loaded components
export var MailFolderContextMenu = createLazyComponent(lazyModule, function (m) { return m.MailFolderContextMenu; });
export var FolderTextField = createLazyComponent(lazyModule, function (m) { return m.FolderTextField; });
//# sourceMappingURL=index.js.map